module.exports = __webpack_public_path__ + "static/media/registration-bottom-blob.14bd0a94.svg";